import React from "react";
import { makeStyles } from "@mui/styles";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import moment from "moment-timezone";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  formControl: {
    margin: theme.spacing(3),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "50%",
  },
  group: {
    margin: `${theme.spacing(1)}px 0`,
  },
  selectInput: {
    backgroundColor: "transparent",
  },
}));


const getDate = (options) => {
  const formatDate = (dt) => {
    return dt.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
      //hour: dt.getHours() !== 0 || dt.getMinutes() !== 0 ? 'numeric' : undefined,
      //minute: dt.getHours() !== 0 ? '2-digit' : undefined
    });
  };
  if (options?.["recur"] === "1" && options?.recurstart && options?.recurend ) {
    const ts = options?.timezone ? moment.tz(options?.recurstart, options?.timezone): moment.tz(options?.recurstart, Intl.DateTimeFormat().resolvedOptions().timeZone)
    const te = options?.timezone ? moment.tz(options?.recurend, options?.timezone): moment.tz(options?.recurend, Intl.DateTimeFormat().resolvedOptions().timeZone)
    //console.log("tt is",ts.format("MMMM Do YYYY, hh:mm: A"))
    return ts.format("MMMM Do YYYY, hh:mm: A")+" to "+te.format("MMMM Do YYYY, hh:mm: A")
    //return formatDate(new Date(options?.recurstart))+" to "+formatDate(new Date(options?.recurend))
  } 
  if (options?.["recur"] === "0" && (options?.fixedstart ?? options?.start) && (options?.fixedend ?? options?.end) ) {
    const ts = options?.timezone ? moment.tz((options?.fixedstart ?? options?.start), options?.timezone): moment.tz((options?.fixedstart ?? options?.start), Intl.DateTimeFormat().resolvedOptions().timeZone)
    const te = options?.timezone ? moment.tz((options?.fixedend ?? options?.end), options?.timezone): moment.tz((options?.fixedend ?? options?.end), Intl.DateTimeFormat().resolvedOptions().timeZone)

    //console.log("tt is",ts.format("MMMM Do YYYY, h:mm A"))
    return ts.format("MMMM Do YYYY, hh:mm: A")+" to "+te.format("MMMM Do YYYY, hh:mm: A")
    //return formatDate(new Date(options?.fixedstart))+" to "+formatDate(new Date(options?.fixedend))
  } 
  return "Start Not Set - End Not Set"
  
};
const ExportPreviewOption = (props) => {
  const { options, setOptions } = props;
  const classes = useStyles();
  const aggregationUnits = {
    hour:'Hourly',
    shift: 'By Shift',
    day: 'Daily' ,
    week: 'Weekly' ,
    month: 'Monthly' ,
    quarter: 'Quarterly' ,
    year: 'Yearly' }
  ;
  return (
    <FormControl
      variant="standard"
      fullWidth={true}
      style={{
        flexDirection: "column",
        margin: 24,
        width: "calc(100% - 48px)",
      }}>
      <FormLabel
        style={{ }}
        component="legend"
      >
        Preview of Export
      </FormLabel>
      <FormControl
        variant="standard"
        //style={{ alignItems: "flex-start" }}
        fullWidth={true}>
        <p style={{"margin":0,paddingBottom:5,paddingTop:10}}>Timezone : <span style={{marginLeft:54}}>{options?.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone}</span></p>
        <p style={{"margin":0,paddingBottom:5}}>Export Schedule : <span style={{marginLeft:10}}>{options?.["sch-desc"] ?? "Not Set"}</span></p>
        <p style={{"margin":0,paddingBottom:5}}>Data to Export : <span style={{marginLeft:23}}>{getDate(options)}</span></p>
        <p style={{"margin":0,paddingBottom:5}}>Aggregation Unit : <span style={{marginLeft:5}}>{aggregationUnits[options?.timerange ?? 'day']}</span></p>
      </FormControl>
    </FormControl>
  );
};

export default ExportPreviewOption;
